
export default {
  name: 'GrievancepolicyContentUZ'
}
